import React, { useEffect, useRef, useState } from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import axios from 'axios';
import AppStrings from '../../config/appstring';

function CustomTable1({ onClose, onCollectFeeClick }) {
  const [items, setItems] = useState([]);
  const [checkedItems, setCheckedItems] = useState({});
  const [title, setTitle] = useState('');
  const titleInputRef = useRef(null);
  const [formData, setFormData] = useState({ ADDFEES: '' });

  useEffect(() => {
    axios.get(AppStrings.ReportHeaderList)
      .then((response) => {
        setItems(response.data.data);
      })
      .catch((error) => {
        console.error('Error fetching items:', error);
      });

    if (titleInputRef.current) {
      titleInputRef.current.focus();
    }
  }, []);

  const onDragEnd = (result) => {
    if (!result.destination) return;

    const newItems = Array.from(items);
    const [reorderedItem] = newItems.splice(result.source.index, 1);
    newItems.splice(result.destination.index, 0, reorderedItem);
    setItems(newItems);
  };

  const handleCheckboxChange = (id, children = []) => {
    setCheckedItems((prev) => {
      const newState = { ...prev, [id]: !prev[id] };
      if (children.length > 0) {
        children.forEach((child) => {
          newState[child.SNO] = !prev[id];
        });
      }
      return newState;
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const buildGroupedHeaders = () => {
    const groupedHeaders = [];
    items.forEach((item) => {
      if (Array.isArray(item.children)) {
        const selectedColumns = [];
        item.children.forEach((child) => {
          if (checkedItems[child.SNO]) {
            let key = '';
            if (child.QRY && child.QRY.toLowerCase().includes(' as ')) {
              key = child.QRY.split(/ as /i)[1].trim();
            } else {
              key = child.KEYS || child.COLUMNNAME || child.HEADERNAME;
            }
           // console.log(child,'kkkkkkkkkkkk')
            selectedColumns.push({
              key: key,
              label: child.COLUMNNAME || child.HEADERNAME,
            });
          }
        });

        if (selectedColumns.length > 0) {
          groupedHeaders.push({
            group: item.HEADERNAME || item.name,
            columns: selectedColumns,
          });
        }
      }
    });
    return groupedHeaders;
  };

  const buildCommonData = () => {
    const selectedNames = [];
    const sumNames = [];
    const countNames = [];
    const EmptyNames = [];

    items.forEach((item) => {
      if (Array.isArray(item.children)) {
        item.children.forEach((child) => {
          if (checkedItems[child.SNO]) {
            if (child.GRP_BY === '1') {
              selectedNames.push(child.QRY);
              EmptyNames.push(child.UNIONCOLUMN);
            } else if (child.GRP_BY === '0') {
              sumNames.push(child.QRY);
            } else if (child.GRP_BY === '2') {
              countNames.push(child.QRY);
            }
          }
        });
      }
    });

    return {
      selectedNames,
      sumNames,
      countNames,
      EmptyNames,
      groupedHeaders: buildGroupedHeaders(),
    };
  };

  const onAddClick = async () => {
    const { selectedNames, sumNames, EmptyNames, groupedHeaders } = buildCommonData();

    //console.log(groupedHeaders,'ggggggggggggg')

    if (selectedNames.length === 0 || title.trim() === "") {
      alert('No fields selected or title missing.');
      return;
    }

    //console.log(groupedHeaders,'grouptest')

    const payload = {
      Datas: {
        Type: '1',
        Sno: '',
        Title: title,
        ColumnName: selectedNames.join(', '),
        Sum: sumNames.join(', '),
        Empty: EmptyNames.join(', '),
        Where: formData.ADDFEES,
         Where2:formData.WHERENAME||'',
         Where3:formData.WHERECONT||'',
        Headers: groupedHeaders,
      }
    };

    try {
      const res = await fetch(AppStrings.QryList, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const result = await res.json();
      alert(result.message || "Data saved successfully!");
      onClose();
    } catch (err) {
      console.error("Error:", err);
      alert("Failed to save data.");
    }
  };

  const onAddClick1 = async () => {

   

    const { selectedNames, sumNames, EmptyNames, groupedHeaders } = buildCommonData();
  console.log(groupedHeaders,'ggggggggggggg')
    if (selectedNames.length === 0) {
      alert('No fields selected.');
      return;
    }

    const payload = {
      Datas: {
        Type: '2',
        Sno: '',
        Title: title,
        ColumnName: selectedNames.join(', '),
        Sum: sumNames.join(', '),
        Empty: EmptyNames.join(', '),
        Where: formData.ADDFEES,
         Where2:formData.WHERENAME||'',
         Where3:formData.WHERECONT||'',
        Headers: groupedHeaders,
      }
    };

    console.log(payload,'pay')

    if (onCollectFeeClick) {
      onCollectFeeClick(payload);
    }
  };

  return (
    <div style={styles.container}>
      <div>Customized Reports</div>
      <div className="row">
        <div className="col-25">
          <div className="coolinput">
            <label htmlFor="input" className="text">Student Type</label>
            <select
              name="ADDFEES"
              value={formData.ADDFEES}
              onChange={handleChange}
              className="input"
            >
              <option value="">SELECT</option>
              <option value="MET">MATRIC</option>
              <option value="CBSE">CBSE</option>
            </select>
          </div>
        </div>
      </div>
        <div className="row">
        <div className="col-25">
          <div className="coolinput">
            <select
              name="WHERENAME"
              value={formData.WHERENAME}
              onChange={handleChange}
              className="input"
            >
              <option value="">SELECT</option>
              <option value="CLASS">CLASS</option>
            </select>
          </div>
        </div>
         <div className="col-75">
          <div className="coolinput">
             <input
            type="text"
            name="WHERECONT"
            className="input" 
            value={formData.WHERECONT}
     onChange={handleChange}
            ref={titleInputRef}
            autoComplete="off"
          />
          </div>
        </div>
      </div>
<br></br>
      <DragDropContext onDragEnd={onDragEnd}>
        <Droppable droppableId="droppable">
          {(provided) => (
            <div {...provided.droppableProps} ref={provided.innerRef} style={styles.list}>
              {items.map((item, index) => (
                <Draggable key={item.SNO} draggableId={item.SNO.toString()} index={index}>
                  {(provided, snapshot) => (
                    <div
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                      style={{
                        ...styles.item,
                        ...provided.draggableProps.style,
                        background: snapshot.isDragging ? '#cce5ff' : '#fff',
                      }}
                    >
                      <label style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                        <input
                          type="checkbox"
                          checked={checkedItems[item.SNO] || false}
                          onChange={(e) => {
                            e.stopPropagation();
                            handleCheckboxChange(item.SNO, item.children || []);
                          }}
                          style={{ marginRight: '10px' }}
                        />
                        {item.HEADERNAME || item.name}
                      </label>

                      {Array.isArray(item.children) && item.children.length > 0 && (
                        <div style={styles.subList}>
                          {item.children.map((child) => (
                            <div key={child.SNO} style={styles.subItem}>
                              <label style={{ display: 'flex', alignItems: 'center' }}>
                                <input
                                  type="checkbox"
                                  checked={checkedItems[child.SNO] || false}
                                  onChange={() => handleCheckboxChange(child.SNO)}
                                  style={{ marginRight: '8px' }}
                                />
                                {child.COLUMNNAME || child.HEADERNAME}
                              </label>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>

      <br />
      <div className="row">
        <div className="coolinput">
          <label className="text">Title</label>
          <input
            type="text"
            name="F_OCCUPATION"
            className="input"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            ref={titleInputRef}
            autoComplete="off"
          />
        </div>
      </div>

      <div className="Buttonrow">
        <div className="Bcol-25">
          <button onClick={onAddClick}><span>Add</span></button>
        </div>
        <div className="Bcol-75">
          <button onClick={onAddClick1}><span>View</span></button>
        </div>
      </div>
    </div>
  );
}

const styles = {
  container: {
    width: '100%',
    height: '85vh',
    padding: '20px',
    background: '#f8f9fa',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    fontSize: '12px',
  },
  list: {
    background: '#e9ecef',
    padding: 10,
    borderRadius: 4,
    flex: 1,
   //  height: '400px', 
    overflowY: 'auto',
   
  },
  item: {
    padding: 12,
    marginBottom: 8,
    backgroundColor: '#fff',
    borderRadius: 4,
    border: '1px solid #ccc',
    cursor: 'grab',
    userSelect: 'none',
  },
  subList: {
    marginTop: 8,
    marginLeft: 20,
    paddingLeft: 10,
    borderLeft: '2px solid #ddd',
  },
  subItem: {
    padding: 6,
    backgroundColor: '#f1f1f1',
    borderRadius: 4,
    marginBottom: 4,
  },
};

export default CustomTable1;
